/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 */
import React, { Component } from 'react';
import WhatShot from 'material-ui/svg-icons/social/whatshot';
import { EditableInline } from '../text';
import Filter from './filter';
import Container from './container';
import { TextField } from 'material-ui';
import { RemoteCheckboxGroup } from '../../components/data-containers';



const filter = {
    concept: '',
    applicable: []
};

class FilterContainer extends Component {

    constructor(props) {
        super(props);
        this.state = { ...filter };
    }


    updateValue = (path, value) => {
        this.setState({ [path]: value });
    };

    render() {
        const { children, onSearch, onClear } = this.props;

        const { concept, applicable } = this.state;
        return (
            <Container
                contents={children}
                onSearch={() => onSearch(this.state)}
                onClear={() => {
                  this.setState({ ...filter})
                  onClear(this.state);
                }}
            >
                <Filter icon={<WhatShot />} title="Concepto" id="concepto">
                    <TextField
                        hintText="concepto"
                        fullWidth
                        value={concept}
                        onChange={(event, value) => this.updateValue('concept', value)}
                    />
                </Filter>
                <Filter icon={<WhatShot />} title="Aplicable" id="aplicable">
                    <RemoteCheckboxGroup
                        selectedValues={applicable}
                        dataType={RemoteCheckboxGroup.TYPES.APPLICABLES}
                        displayProp={(item) => item.name}
                        valueProp="id"
                        notify={(checkedValues) =>
                            this.updateValue('applicable', checkedValues)
                        }
                    />
                </Filter>
            </Container>
        );
    }
}

export default FilterContainer;



// WEBPACK FOOTER //
// ./components/filters/conceptos.js